import * as React from "react";

const UserCircleIcon = ({ color = "#596375", ...props }: React.SVGProps<SVGSVGElement> & { color?: string }) => (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <circle cx="10" cy="10" r="7.5" stroke={color} strokeWidth={1.5} />
        <path d="M6.625 13.75C8.37378 11.9184 11.6074 11.8321 13.375 13.75M11.8713 8.125C11.8713 9.16053 11.0307 10 9.99365 10C8.95664 10 8.11598 9.16053 8.11598 8.125C8.11598 7.08947 8.95664 6.25 9.99365 6.25C11.0307 6.25 11.8713 7.08947 11.8713 8.125Z" stroke={color} strokeWidth={1.5} strokeLinecap="round" />
    </svg>
);

export default UserCircleIcon; 